// HelpingFamiliesSection.js
import React from "react";
import { Phone } from "lucide-react";
import helpingFamiliesImage from "../assets/helping-families-image.jpg";

const HelpingFamiliesSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Helping Families Worry Less and Smile More
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                Seniors don't want to relocate to unfamiliar care facilities,
                but the complications of living alone in their own homes can be
                dangerous. Seniors living alone are prone to accidental
                overdoses, falls, malnutrition, anxiety, depression, and medical
                emergencies.
              </p>

              <p>
                Allawah Lodge is the answer to these problems. Our home care
                services create the opportunity for at-risk seniors to remain in
                the communities they know and love without risking these
                dangers. Our caregivers provide companionship, customised
                personal care, homemaking assistance, and respite care for the
                family caregivers. We ensure your loved ones stay safe, happy,
                and independent at home.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={helpingFamiliesImage}
              alt="Caregiver with elderly woman"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HelpingFamiliesSection;
